console.debug('AwayJS - Stage - 0.11.82');
export { AGALMiniAssembler } from './lib/aglsl/assembler/AGALMiniAssembler';
export { Flags } from './lib/aglsl/assembler/Flags';
export { FS } from './lib/aglsl/assembler/FS';
export { Opcode } from './lib/aglsl/assembler/Opcode';
export { OpcodeMap } from './lib/aglsl/assembler/OpcodeMap';
export { Part } from './lib/aglsl/assembler/Part';
export { RegMap } from './lib/aglsl/assembler/RegMap';
export { Sampler } from './lib/aglsl/assembler/Sampler';
export { SamplerMap } from './lib/aglsl/assembler/SamplerMap';
export { AGALTokenizer } from './lib/aglsl/AGALTokenizer';
export { AGLSLParser } from './lib/aglsl/AGLSLParser';
export { Description } from './lib/aglsl/Description';
export { Destination } from './lib/aglsl/Destination';
export { Header } from './lib/aglsl/Header';
export { Mapping } from './lib/aglsl/Mapping';
export { OpLUT } from './lib/aglsl/OpLUT';
export { Token } from './lib/aglsl/Token';
export { ContextGLBlendFactor } from './lib/base/ContextGLBlendFactor';
export { ContextGLClearMask } from './lib/base/ContextGLClearMask';
export { ContextGLCompareMode } from './lib/base/ContextGLCompareMode';
export { ContextGLDrawMode } from './lib/base/ContextGLDrawMode';
export { ContextGLMipFilter } from './lib/base/ContextGLMipFilter';
export { ContextGLProfile } from './lib/base/ContextGLProfile';
export { ContextGLProgramType } from './lib/base/ContextGLProgramType';
export { ContextGLStencilAction } from './lib/base/ContextGLStencilAction';
export { ContextGLTextureFilter } from './lib/base/ContextGLTextureFilter';
export { ContextGLTextureFormat } from './lib/base/ContextGLTextureFormat';
export { ContextGLTriangleFace } from './lib/base/ContextGLTriangleFace';
export { ContextGLVertexBufferFormat } from './lib/base/ContextGLVertexBufferFormat';
export { ContextGLWrapMode } from './lib/base/ContextGLWrapMode';
export { ContextMode } from './lib/base/ContextMode';
export { SamplerState } from './lib/base/SamplerState';
export { TouchPoint } from './lib/base/TouchPoint';
export { ImageEvent } from './lib/events/ImageEvent';
export { StageEvent } from './lib/events/StageEvent';
export { RTTEvent } from './lib/events/RTTEvent';
export { BitmapImage2D, _Stage_BitmapImage2D } from './lib/image/BitmapImage2D';
export { BitmapImageChannel } from './lib/image/BitmapImageChannel';
export { BitmapImageCube, _Stage_BitmapImageCube } from './lib/image/BitmapImageCube';
export { BlendMode } from './lib/image/BlendMode';
export { ExternalImage2D, _Stage_ExternalImage2D } from './lib/image/ExternalImage2D';
export { Image2D, _Stage_Image2D } from './lib/image/Image2D';
export { ImageBase, _Stage_ImageBase } from './lib/image/ImageBase';
export { ImageCube, _Stage_ImageCube } from './lib/image/ImageCube';
export { ImageData } from './lib/image/ImageData';
export { ImageSampler } from './lib/image/ImageSampler';
export { SpecularImage2D } from './lib/image/SpecularImage2D';
//export {VideoSourceImage2D} from "./lib/image/VideoSourceImage2D";
export { DefaultGraphicsFactory } from './lib/factories/DefaultGraphicsFactory';
export { CompositeTask as Filter3DCompositeTask } from './lib/filters/tasks/CompositeTask';
export { FXAATask as Filter3DFXAATask } from './lib/filters/tasks/FXAATask';
export { BlurTask as Filter3DBlurTask } from './lib/filters/tasks/BlurTask';
export { TaskBase as Filter3DTaskBase } from './lib/filters/tasks/TaskBase';
export { BlurFilter as BlurFilter3D } from './lib/filters/BlurFilter';
export { CompositeFilter as CompositeFilter3D } from './lib/filters/CompositeFilter';
export { FilterBase as Filter3DBase } from './lib/filters/FilterBase';
export { FXAAFilter as FXAAFilter3D } from './lib/filters/FXAAFilter';
export { ContextGLES } from './lib/gles/ContextGLES';
export { GLESConnector } from './lib/gles/GLESConnector';
export { GLESAssetBase } from './lib/gles/GLESAssetBase';
export { CubeTextureGLES } from './lib/gles/CubeTextureGLES';
export { IndexBufferGLES } from './lib/gles/IndexBufferGLES';
export { ProgramGLES } from './lib/gles/ProgramGLES';
export { TextureBaseGLES } from './lib/gles/TextureBaseGLES';
export { TextureGLES } from './lib/gles/TextureGLES';
export { VertexBufferGLES } from './lib/gles/VertexBufferGLES';
export { ProgramData } from './lib/image/ProgramData';
export { ProgramDataPool } from './lib/image/ProgramDataPool';
export { StageManager } from './lib/managers/StageManager';
export { RTTBufferManager } from './lib/managers/RTTBufferManager';
export { Image2DParser } from './lib/parsers/Image2DParser';
export { ImageCubeParser } from './lib/parsers/ImageCubeParser';
export { TextureAtlasParser } from './lib/parsers/TextureAtlasParser';
export { RegisterPool } from './lib/shaders/RegisterPool';
export { ShaderRegisterCache } from './lib/shaders/ShaderRegisterCache';
export { ShaderRegisterData } from './lib/shaders/ShaderRegisterData';
export { ShaderRegisterElement } from './lib/shaders/ShaderRegisterElement';
export { ContextSoftware } from './lib/software/ContextSoftware';
export { IndexBufferSoftware } from './lib/software/IndexBufferSoftware';
export { ProgramSoftware } from './lib/software/ProgramSoftware';
export { ProgramVOSoftware } from './lib/software/ProgramVOSoftware';
export { SoftwareSamplerState } from './lib/software/SoftwareSamplerState';
export { TextureSoftware } from './lib/software/TextureSoftware';
export { VertexBufferSoftware } from './lib/software/VertexBufferSoftware';
export { ContextWebGL } from './lib/webgl/ContextWebGL';
export { CubeTextureWebGL } from './lib/webgl/CubeTextureWebGL';
export { IndexBufferWebGL } from './lib/webgl/IndexBufferWebGL';
export { ProgramWebGL } from './lib/webgl/ProgramWebGL';
export { TextureBaseWebGL } from './lib/webgl/TextureBaseWebGL';
export { TextureWebGL } from './lib/webgl/TextureWebGL';
export { VertexBufferWebGL } from './lib/webgl/VertexBufferWebGL';
export { BitmapImageUtils } from './lib/utils/BitmapImageUtils';
export { ImageUtils } from './lib/utils/ImageUtils';
export { AttributesView } from './lib/attributes/AttributesView';
export { AttributesBuffer, _Stage_AttributesBuffer } from './lib/attributes/AttributesBuffer';
export { Byte4Attributes } from './lib/attributes/Byte4Attributes';
export { Float1Attributes } from './lib/attributes/Float1Attributes';
export { Float2Attributes } from './lib/attributes/Float2Attributes';
export { Float3Attributes } from './lib/attributes/Float3Attributes';
export { Float4Attributes } from './lib/attributes/Float4Attributes';
export { Short2Attributes } from './lib/attributes/Short2Attributes';
export { Short3Attributes } from './lib/attributes/Short3Attributes';
export { Stage } from './lib/Stage';
export { ContextWebGLFlags } from './lib/webgl/ContextWebGLFlags';
import { Loader } from '@awayjs/core';
import { Image2DParser } from './lib/parsers/Image2DParser';
import { ImageCubeParser } from './lib/parsers/ImageCubeParser';
import { TextureAtlasParser } from './lib/parsers/TextureAtlasParser';
export * from './lib/Settings';
Loader.enableParser(Image2DParser);
Loader.enableParser(ImageCubeParser);
Loader.enableParser(TextureAtlasParser);
